export const defaultTypes = {
  id: 0,
  name: '',
  logoUrl: '',
  addressOne: '',
  addressTwo: '',
  city: '',
  state: '',
  zip: '',
  countryCode: '',
  phone: '',
  fax: '',
  website: '',
  emailOne: '',
  currency: null,
};
